import { render, staticRenderFns } from "./testDialog.vue?vue&type=template&id=b9a1db76"
import script from "./testDialog.vue?vue&type=script&lang=js"
export * from "./testDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports